// extracted by mini-css-extract-plugin
module.exports = {"trustedRetailerBanner":"Le-z","trustedRetailerTooltipWrapper":"Me-z"};